













import Vue, {VueConstructor} from 'vue'
import Messenger from '@/components/Messenger/Messenger.vue'
import {RawMessage} from '@/types/entity/RawMessage'
import Message from '@/models/Message/Message'
import _ from 'lodash'
import {Dictionary} from 'vuex'
import Student from '@/models/Students/Student'
import {USER_ROLE_CHAT} from '@/constants'
import store from '@/store'
import auth from 'src/services/auth'

const MSGS_LOAD_LIMIT = 7
const MSGS_WATCHER_PERIOD = 7000

export default (Vue as VueConstructor<Vue & {
  $refs: {
    messenger: {
      freezeScroll: () => void,
      slideScrollToBottom: () => void,
      clearMessageText: () => void,
      getVisibleGroups: () => Dictionary<Message[]>,
      setInputDisabled: (val: boolean) => void
    }
  }
}>).extend({
  components: {Messenger},
  props: {
    lsnId: String,
    hasPerm: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      list: [] as Message[],
      interval: null,
      isLoading: false
    }
  },
  computed: {
    admin (): boolean {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_CHAT)
      }
      return false
    },
    lastId (): string | null {
      if (this.list.length) {
        return this.list[this.list.length - 1].getId()
      } else {
        return null
      }
    },
    firstId (): string | null {
      if (this.list.length) {
        return this.list[0].getId()
      } else {
        return null
      }
    },
  },
  methods: {
    async preLoad (): Promise<void> {
      try {
        this.isLoading = true;
        setTimeout(() => {
          store.commit('appInterface/setLoaderBar', true);
        }, 1000)
        let msgs = await this.listLoader({limit: MSGS_LOAD_LIMIT})
        this.addMesseges(msgs)
        this.slideScrollToBottom()

        if (msgs) {
          this.dataWatcher();
        }
      } catch (error) {
        console.error('preLoad: error', error)

        if (this.$store.state.user.user) {
          // @ts-ignore
          this.$message.error(this.$t('students.messenger.can_not_download_messages_history'))
        }
      } finally {
        store.commit('appInterface/setLoaderBar', false);
        setTimeout(() => {
          store.commit('appInterface/setLoaderBar', false);
        }, 1001)
        this.isLoading = false;
      }
    },
    async addLoad (): Promise<void> {
      try {
        store.commit('appInterface/setLoaderBar', true);
        let msgs = await this.listLoader({limit: MSGS_LOAD_LIMIT, after: false, msg_id: this.firstId || undefined})
        this.addMesseges(msgs)
        this.freezeScroll();
      } catch (error) {
        console.error('addLoad: error', error)

        if (this.$store.state.user.user) {
          // @ts-ignore
          this.$message.error(this.$t('students.messenger.can_not_download_messages_history'))
        }
      } finally {
        store.commit('appInterface/setLoaderBar', false);
      }
    },
    async newLoad (): Promise<void> {
      if (auth.isAuthenticated() === null) {
        return;
      }

      try {
        let msgs = await this.listLoader({limit: MSGS_LOAD_LIMIT, after: true, msg_id: this.lastId || undefined})
        if (msgs && msgs.length) {
          this.addMesseges(msgs, true)
          this.slideScrollToBottom()
        }
      } catch (error) {
        // @ts-ignore
        // this.$message.error(this.$t('students.messenger.can_not_download_new_messages'))
      }
    },
    async updateData (): Promise<void> {
      try {
        const ids = []
        const visGroups = this.$refs.messenger && this.$refs.messenger.getVisibleGroups()

        if (visGroups) {
          for (const group in visGroups) {
            if (visGroups.hasOwnProperty(group)) {
              const messages = visGroups[group];
              for (const message of messages) {
                ids.push(message.getId())
              }
            }
          }
        }

        if (ids.length) {
          await this.$store.dispatch('messages/getMessages', {msg_ids: ids})
        }
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('students.messenger.can_not_update_messages_data'))
      }
    },
    onScrollUp () {
      this.addLoad();
    },
    addMesseges (msgs: Message[], push = false) {
      if (msgs && msgs.length) {
        for (const msg of msgs) {
          if (push) {
            this.list.push(msg);
          } else {
            this.list.unshift(msg);
          }
        }
      }
    },
    async onInput (text: string) {
      try {
        this.$refs.messenger.setInputDisabled(true)
        const {msg_id} = await this.$store.dispatch('messages/postMessage', {chat_id: this.lsnId, text})
        if (msg_id) {
          let messages = await this.$store.dispatch('messages/getMessages', {msg_ids: [msg_id]})
          this.$refs.messenger.setInputDisabled(false)
          this.addMesseges(messages, true);
          this.$refs.messenger.clearMessageText();
          this.slideScrollToBottom();
        } else {
          throw new Error(`msg_id is ${msg_id}`)
        }
      } catch (error) {
        this.$refs.messenger.setInputDisabled(false)
        // @ts-ignore
        this.$message.error(this.$t('students.messenger.can_not_send_message'))
      }
    },
    async listLoader (params?: any): Promise<Message[]> {
      let messeges = await this.$store.dispatch('messages/listMessages', {chat_id: this.lsnId, ...params})
      return messeges
    },
    dataWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        this.newLoad()
        // this.updateData();
      }, MSGS_WATCHER_PERIOD)
    },
    slideScrollToBottom () {
      this.$nextTick(() => {
        if (this.$refs.messenger) {
          this.$refs.messenger.slideScrollToBottom();
        }
      })
    },
    freezeScroll () {
      this.$nextTick(() => {
        if (this.$refs.messenger) {
          this.$refs.messenger.freezeScroll();
        }
      })
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    },
    onWindowFocus (): void {
      if (this.$store.state.user.user && !this.interval) {
        this.dataWatcher();
      }
    }
  },
  mounted () {
    if (this.hasPerm) {
      this.preLoad();
    }
    // this.$root.$on('on-login', this.dataWatcher)
    // this.$root.$on('relogin', this.clearInterval)
    // this.$root.$on('on-window-focus', this.onWindowFocus)
  },
  beforeDestroy () {
    this.clearInterval()
    // this.$root.$off('relogin', this.clearInterval)
    // this.$root.$off('on-login', this.dataWatcher)
    // this.$root.$off('on-window-focus', this.onWindowFocus)
  }
})
